import HeroSection from './HeroSection/PlanHeroSection';
import WarrantySection from './WarrantySection/PlanWarrantySection';
import ServicePlanHighlight from './ServicePlanHighlight/PlanServicePlanHighlight';
import FindADealer from './FindADealer/PlanFindADealer';

export async function generateMetadata() {
  return {
    title: 'Service Plan | JAECOO',
    description:
      'Get peace of mind with our comprehensive service plans. Affordable, inflation-proof maintenance with genuine parts and expert technicians.',
  };
}

const ServicePlanPage = ({ fields }) => {
  // 安全的字段提取函数
  const getFieldValue = (field) => {
    if (field?.value !== undefined) {
      return field.value;
    }
    return typeof field === 'string' ? field : '';
  };

  // 映射Hero数据，支持两种数据格式
  const heroData = {
    image: fields?.heroImage,
    title: getFieldValue(fields?.heroTitle),
  };

  // 映射Warranty数据
  const warrantyData = fields?.warrantyItem || [];

  // 映射Service Plan数据
  const servicePlanData = {
    title: getFieldValue(fields?.planTitle),
    imageItems: fields?.planImageItem || [],
  };

  // 映射Find Dealer数据，支持两种数据格式
  const findDealerData = {
    text: getFieldValue(fields?.findText),
    image: fields?.findImage,
    buttonText: getFieldValue(fields?.buttonText),
    buttonUrl: fields?.buttonUrl?.value?.href || getFieldValue(fields?.buttonUrl),
    isComingSoon:
      (fields?.isComingSoon?.value !== undefined
        ? fields?.isComingSoon?.value
        : fields?.isComingSoon) || false,
  };

  return (
    <div className="container">
      <HeroSection data={heroData} />
      <WarrantySection data={warrantyData} />
      {/* <ServicePlanHighlight data={servicePlanData} /> */}
      <FindADealer data={findDealerData} />
    </div>
  );
};

export default ServicePlanPage;
